import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { getStorageValues } from '../../shared/CommonFunctions';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import EnquiryModal from './EnquiryModal';
import EnquiryGrid from './EnquiryGrid';
import { fetchEnquiryList, saveEnquiry, deleteEnquiry as deleteEnquiryApi } from '../../utils/enquiryApi';
import { logAuditEvent } from '../../utils/auditLogger';

function EnquiryMain(props) {
  const [enquiryList, setEnquiryList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const [userAction, setUserAction] = useState('Add');
  const [selectedRow, setSelectedRow] = useState(null);
  const moduleName = props.Module || 'Customer Enquiry';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchEnquiries();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Customer Enquiry');
  }, [moduleName]);

  function openAddModal() {
    setUserAction('Add');
    setSelectedRow(null);
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add enquiry modal');
  }

  function openEditModal(row) {
    setUserAction('Edit');
    setSelectedRow(row);
    setIsOpen(true);
  }

  function openViewModal(row) {
    setUserAction('View');
    setSelectedRow(row);
    setIsOpen(true);
  }

  function openDeleteModal(row) {
    setUserAction('Delete');
    setSelectedRow(row);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    const actionName = e?.target?.name;
    const currentUserId = getStorageValues('userId');

    if (actionName === 'Delete') {
      if (!selectedRow?.EnquiryId) {
        CreateAlert('Please select a record to delete.', 'Error', setAlert);
        return;
      }
      try {
        const response = await deleteEnquiryApi({ enquiryId: selectedRow.EnquiryId, userId: currentUserId });
        CreateAlert(response?.data?.message || 'Deleted', 'Success', setAlert);
        await fetchEnquiries();
        closeModal();
      } catch (error) {
        console.log(error);
        CreateAlert('Error deleting enquiry.', 'Error', setAlert);
      }
      return;
    }

    if (!data || !data.CustomerName || !String(data.CustomerName).trim()) {
      CreateAlert('Customer Name is required!!', 'Warning', setAlert);
      return;
    }

    const enquirySourceLabel = String(data.EnquirySourceLabel || '').toLowerCase();
    const enquirySourceValue = String(data.EnquirySource || '').toLowerCase();
    const isReferenceSource = enquirySourceLabel === 'reference' || enquirySourceValue === 'reference';
    if (isReferenceSource && !String(data.ReferenceName || '').trim()) {
      CreateAlert('Reference Name is required when Enquiry Source is Reference.', 'Warning', setAlert);
      return;
    }

    try {
      const response = await saveEnquiry({
        enquiryId: actionName === 'Edit' ? selectedRow?.EnquiryId : null,
        customerName: data.CustomerName,
        mobileNo: data.MobileNo,
        enquirySource: data.EnquirySource,
        referenceName: data.ReferenceName,
        area: data.Area,
        vehicleEnquiries: data.VehicleEnquiries || [],
        userId: currentUserId
      });
      const spResult = response?.data;
      if (spResult && Number(spResult.success) === 0) {
        CreateAlert(spResult.message || 'Error', 'Error', setAlert);
        return;
      }
      CreateAlert(spResult?.message || 'Saved', 'Success', setAlert);
      await fetchEnquiries();
      closeModal();
    } catch (error) {
      console.log(error);
      CreateAlert('Error saving enquiry.', 'Error', setAlert);
    }
  }

  const fetchEnquiries = async () => {
    try {
      const rows = await fetchEnquiryList({ userId: getStorageValues('userId') });
      setEnquiryList(rows);
    } catch (error) {
      console.log(error);
    }
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Customer Name", selector: "CustomerName" },
      { name: "Mobile Number", selector: "MobileNo" },
      { name: "Enquire For", selector: "EnquireFor" },
    ];
    exportToExcel("Enquiries", columns, enquiryList);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Customer Name", selector: "CustomerName" },
      { name: "Mobile Number", selector: "MobileNo" },
      { name: "Enquire For", selector: "EnquireFor" },
    ];
    exportToPDF("Enquiries", columns, enquiryList);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchEnquiries}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <EnquiryGrid
        enquiryList={enquiryList}
        onAdd={openAddModal}
        onView={openViewModal}
        onEdit={openEditModal}
        onDelete={openDeleteModal}
        UserPermissions={getUserModulePermission}
        moduleName={moduleName}
      />
      <EnquiryModal
        show={modalIsOpen}
        UserAction={userAction}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={selectedRow}
        moduleName ={props.Module}

      />
    </>
  )
}

export default EnquiryMain